/**
 * ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
 * Bangalore, India. All Rights Reserved.
 */
import {
  PolymerElement,
  html
} from "@polymer/polymer/polymer-element.js";
import {
  mixinBehaviors
} from "@polymer/polymer/lib/legacy/class.js";
import '../behaviors/log-out-behaviour.js';
import '../behaviors/mpin-register-behaviour.js';

class mpinPreloginSecurityQuestion extends mixinBehaviors([corpBehaviours.logOutBehaviour, corpBehaviours.mpinRegisterBehaviour], PolymerElement) {
  /** Properties definition*/
  static get properties() {
    return {
      ErrMsg: {
        type: String,
        notify: true
      },
      selectedPage: {
        type: Number,
        notify: true,
        observer: 'addFocusToSecQueHeader'
      },
      eleId: {
        type: String,
        notify: true,
        value: 'mpinSecQues'
      },
      questionList: {
        type: Object,
        notify: true
      },
      selectedQues: {
        type: Array,
        notify: true
      },
      selCount: {
        type: Number,
        notify: true,
        value: 0
      },
      authPage: {
        type: Object,
        value: []
      },
      ansLen: {
        type: Number,
        notify: true
      },
      otpValue: {
        type: String,
        notify: true
      },
      showUserName: {
        type: String,
        notify: true
      },
      hideShowUserName: {
        type: Boolean,
        notify: true,
        value: true
      },
      authorizationDetailsBody: {
        type: Object,
        notify: true
      },
      mpinAuthList: {
        type: Object,
        notify: true
      },
      profilePage: {
        type: Boolean,
        value: false,
        notify: true
      },
      minQuesCount: {
        type: Number,
        value: 2,
        notify: true
      }
    };
  }
  /** HTML template definition*/


  static get template() {
    return html `
        <style include="corp-app-styles">
        .light-checkbox {
                
          --paper-radio-checkmark-color: var(--brand-color);
          --paper-radio-size: 15px;
          --paper-radio-border-radius: 
      }
      .hide {
          display: none
      }
      :dir(ltr) paper-checkbox {
          display: block;
          margin-right: 24px;
      }
:dir(rtl) paper-checkbox {
          display: block;
          margin-left: 24px;
      }
				</style>
 
        <app-media-query phone="{{phone}}" desktop="{{desktop}}" tablet="{{tablet}}"></app-media-query>
        <oe-ajax id="logoutAjax" method="post" content-type="application/json" body="{{objData}}" on-response="_handleResponse" on-error="_handleError"></oe-ajax>
        <oe-ajax id="minQuestionCount"  url="/api/propertyreferences?filter[where][propertyName]=MIN_QUESTION_COUNT" on-response="fetchMinCount" on-error="handleError"
        ></oe-ajax>
    
                        <div class="brand-background-color mdl-grid">
                        <div class="outlineOffset mdl-cell primary-light-text-xl mdl-cell--12-col content-align-center" id="secQueHeader" tabindex="0">       
                            <oe-i18n-msg class="" msgid="l_SetSecurityQues"></oe-i18n-msg>
                 
                            
                        </div>
                        <div class="mdl-cell mdl-cell--12-col text-align-center primary-light-text-s">
                        <oe-i18n-msg msgid="m_forgotPassSeqQue"></oe-i18n-msg>
                    </div>
                        </div>

                        <div class="full-height main-container mdl-cell" wide-layout$="{{wide}}" extra-wide-layout$="{{extra-wide}}">
                            <div phone$="{{phone}}" desktop$="{{desktop}}" tablet$="{{tablet}}" elevation="0">
                                <div class="mdl-grid ">
                            <div class="outlineOffset mdl-cell mdl-cell--3-col-phone secondary-dark-text-m" tabindex="0">
                              <oe-i18n-msg msgid="m_AnsQues" placeholders='["{{minQuesCount}}"]'></oe-i18n-msg>
                            </div>
                            <div class="outlineOffset mdl-cell mdl-cell--1-col-phone cursor-pointer text-brand-color font-medium text-transform-uppercase font-size-m" id="reset_sequrity_ans" tabindex="0" role="button" on-tap="gotoReset" on-keydown="gotoResetDDA" >
                              <oe-i18n-msg id="quesProceed" msgid="b_Reser"></oe-i18n-msg>
                            </div>
                            </div>
                            <div class="mdl-cell mdl-cell--12-col">
                                    <template is="dom-repeat" items="{{questionList}}" as="categoryitem" restamp>
                                        <div class="mdl-cell mdl-cell--12-col margin-l-zero">
                                            <paper-radio-button id="checkbox{{eleId}}{{index}}" class="font-size-inherit" on-tap="showMe">
                                              <span class="light-checkbox primary-dark-text-s">{{displayIndex(index)}} {{categoryitem.question}}</span></paper-radio-button>
                                        </div>
                                        <div id="inputFiled_{{eleId}}{{index}}" class="hide mdl-cell mdl-cell--12-col mdl-grid padding-t-zero margin-l-zero padding-l-zero margin-t-zero margin-l-zero margin-b-zero">
                                            <oe-input id="inputField_{{eleId}}_{{index}}" label="l_Answer" minlength="{{ansLen}}" auto-validate always-float-label on-tap="focusSelInpfield" tabindex="0" class="outlineOffset"></oe-input>
                                        </div>
                                    </template>
                                </div>
                            </div>
                            
                            <div class="btn align-end full-width">
                                <div class="mdl-grid"></div>
                                <div class="mdl-grid mdl-cell mdl-cell--12-col  full-width">
                                    <paper-button id="QuesCancel" class="secondary-button" on-tap="cancelPage" raised>
                                        <oe-i18n-msg id="quesCancel" class="" msgid="b_Cancel"></oe-i18n-msg>
                                    </paper-button>
                                    <paper-button raised class="primary-button" on-tap="postAns">
                                        <oe-i18n-msg id="quesProceed" msgid="b_Continue"></oe-i18n-msg>
                                    </paper-button>
                                </div>
                            </div>
                          </div>
                      
                    <div class="mdl-grid"></div>
                    <div class="mdl-grid"></div>
             
        `;
  }
  focusSelInpfield(e) {
    var id = "#inputField_" + this.eleId + "_" + e.model.index;
    this.$$(id); //this.$$(id).focus();

    window.addEventListener("resize", function () {
      window.setTimeout(function () {
        document.activeElement.scrollIntoViewIfNeeded();
      }, 0);
    });
  }
  cancelPage() {
    if (!this.profilePage) {
      this.gotoReset();
      this.goToLoginPage();
    } else {
      this.backToMyProfile();
    }
  }
  showMe(e) {
    if (this.$$("#inputFiled_" + this.eleId + e.model.index).classList.contains("hide")) {
      this.selCount += 1;
      this.$$("#inputFiled_" + this.eleId + e.model.index).classList.remove("hide");
    } else {
      this.selCount -= 1;
      this.$$("#inputFiled_" + this.eleId + e.model.index).classList.add("hide");
      this.$$("#inputField_" + this.eleId + "_" + e.model.index).value = "";
    }
  }
  gotoReset() {
    if (this.questionList != null) {
      for (var i = 0; i < this.questionList.length; i++) {
        this.selCount = 0;
        this.$$("#inputFiled_" + this.eleId + i).classList.add("hide");
        this.$$("#inputField_" + this.eleId + "_" + i).value = "";
        this.$$("#checkbox" + this.eleId + i).disabled = false;
        this.$$("#checkbox" + this.eleId + i).checked = false;
      }
    }
  }
  fetchMinCount(e) {
    this.minQuesCount = e.detail.response[0].propertyValue;
  }
  keyEnterAction(keyboardEvent) {
    // enter pressed!
    if (keyboardEvent.keyCode === 13) {
      this.closeDialog();
      window.parent.document.getElementById(this.eleId).close();
    }
  }
  postAns() {
    var tempDateGroups = [];
    this.selectedQues = [];
    var list = [];
    for (var i = 0; i < this.questionList.length; i++) {
      if (this.$$("#checkbox" + this.eleId + i).checked) {
        if (this.$$("#inputField_" + this.eleId + "_" + i).value != "" && this.$$("#inputField_" + this.eleId + "_" + i).value != undefined) {
          list = {
            "questionId": this.questionList[i].questionId,
            "question": this.questionList[i].question,
            "answer": this.$$("#inputField_" + this.eleId + "_" + i).value
          };
          tempDateGroups.push(list);
        } else {
          this.fire('oe-show-error', "m_ansSeqQues");
          return;
        }
      }
    }
    if (this.selCount >= this.minQuesCount) {
      this.selectedQues = tempDateGroups;
      if (this.selectedQues != undefined && this.selectedQues.length > 0) {
        this.enabledAuthList.shift();
        if (this.mpinAuthList && this.mpinAuthList.authenticationDetails && this.mpinAuthList.authenticationDetails.securityQuestionAnswers) this.authorizationDetailsBody.securityQuestionAnswers = this.selectedQues;
        if (this.enabledAuthList.length > 0) this.selectedPage = this.authPage[this.enabledAuthList[0]];
        else this.postRequest();
      } else if (this.selectedQues != undefined && this.selectedQues.length == 0) {
        this.fire('oe-show-error', "m_selectSeqQue");
      }
    } else {
      this.fire('oe-show-error', "m_ansMinSeqQues");
    }
  }
  displayIndex(i) {
    return i + 1 + ". ";
  }
  addFocusToSecQueHeader() {
    if (this.selectedPage == 1) {
      this.$.minQuestionCount.generateRequest();
      setTimeout(function () {
        this.$$("#secQueHeader").focus();
      }.bind(this), 500);
    }
  }
}
customElements.define('mpin-prelogin-security-question', mpinPreloginSecurityQuestion);